import axios from 'axios';

export const updateClaimStage = async (claimId: number, stageKey: string) => {
  await axios.post(`/api/v1/claims/${claimId}/stage/${stageKey}`);
};
